var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 23.733 23.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M622.4,235.121h0l1.373-.541a.617.617,0,0,1,.837.475l.437,2.713.024.024,2.548.23a.618.618,0,0,1,.494.9l-.658,1.26h0l12.37-12.371a.616.616,0,0,0,0-.87l-4.185-4.185a.616.616,0,0,0-.87,0Z",
    transform: "translate(-619.672 -219.349)",
    fill: "#734bd1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M565.805,505.674a.591.591,0,0,0,.713.7l5.648-1.369a.268.268,0,0,0,.183-.154l.993-2.366a.269.269,0,0,0-.251-.371l-2.6.034a.268.268,0,0,1-.27-.246l-.2-2.814a.266.266,0,0,0-.357-.231l-2.414.887a.263.263,0,0,0-.169.193Z",
    transform: "translate(-565.79 -482.742)",
    fill: "#734bd1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M951.5,163.7",
    transform: "translate(-933.25 -163.311)",
    fill: "#734bd1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M909.853,156.7h0a3.667,3.667,0,0,0-4.959-.207l-.019-.019L903,158.357l0,0a.635.635,0,0,1,.843.048l4.289,4.289a.634.634,0,0,1,.048.843h0l1.639-1.638,0,0,.019-.019A3.672,3.672,0,0,0,909.853,156.7Z",
    transform: "translate(-887.189 -155.631)",
    fill: "#734bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3302d230a2ef370ddbf83e6275094bdc.svg";
export { ForwardRef as ReactComponent };